export default __webpack_public_path__ + "static/media/arrow-right-icon.49c4ec52.svg";